import { Site } from '@envato/foundation-types'
import * as classnames from 'classnames'
import * as React from 'react'

const SearchHeader = ({
  currentSite,
  children,
  styles = {}
}: {
  currentSite: Site
  children: any
  styles: any
}) => {
  const pageSectionClassNames = classnames(
    styles.pageSection,
    'page-section',
    '-size-xcompact',
    `-theme-${currentSite || Site.themeforest}`
  )

  return (
    <div id="search-header">
      <div className={pageSectionClassNames}>
        <div
          className={classnames(
            styles.pageSectionContent,
            'page-section__content'
          )}
        >
          <div
            className={classnames(
              styles.pageSectionBackground,
              'page-section__background'
            )}
          />
          <div
            className={classnames(
              styles.pageSectionForm,
              'search-header__form-wrapper'
            )}
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}

export default SearchHeader
